import * as React from "react"
import { cn } from "@/lib/utils"
import { TextareaAiAddon, type AiFieldKind } from "./improve-with-ai"

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** F-105: shows "Improve with AI" on this field. Only for long, free text (never titles or names). */
  aiFieldKind?: AiFieldKind
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, aiFieldKind, ...props }, ref) => {
    const inner = React.useRef<HTMLTextAreaElement | null>(null)
    const setRef = React.useCallback((el: HTMLTextAreaElement | null) => {
      inner.current = el
      if (typeof ref === "function") ref(el)
      else if (ref) ref.current = el
    }, [ref])
    const textarea = (
      <textarea
        className={cn(
          "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-200 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50",
          aiFieldKind && "pb-10",
          className
        )}
        ref={setRef}
        {...props}
      />
    )
    if (!aiFieldKind) return textarea
    return (
      <div className="relative w-full min-w-0">
        {textarea}
        <TextareaAiAddon target={inner} value={props.value} fieldKind={aiFieldKind} maxLength={props.maxLength}
          disabled={props.disabled || props.readOnly} className="absolute bottom-1 right-1" />
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
